import SG_AREA from '@/config/city.json'

const addressSelectObj = {
    getProvince() {
        let provinces = []
        for (let key in SG_AREA) {
            provinces.push({
                name: SG_AREA[key].name,
                code: key
            })
        }
        return provinces
    },
    getCity(provinceId = 0) {
        let cities = []
        let province = SG_AREA[provinceId]
        if (province) {
            for (let key in province.city) {
                cities.push({
                    name: province.city[key].name,
                    code: key
                })
            }
        }
        return cities
    },
    getDistrict(provinceId = 0, cityId = 0) {
        let districts = []
        if (!!provinceId && !!cityId) {
            let city = SG_AREA[provinceId].city[cityId].areas
            for (let key in city) {
                districts.push({
                    name: city[key].name,
                    code: key
                })
            }
        }
        return districts
    },
    getProvinceName(provinceCode) {
        return SG_AREA[provinceCode].name
    },
    getCityName(provinceCode, cityCode) {
        return SG_AREA[provinceCode].city[cityCode].name
    },
    getDistrictName(provinceCode, cityCode, districtCode) {
        return SG_AREA[provinceCode].city[cityCode].areas[districtCode].name
    },
    // 根据省市区名称获取code
    initProviceAndCityCode(province, city, district) {
        let result = {
            province_code: 0,
            city_code: 0,
            district_code: 0
        }
        for (let key in SG_AREA) {
            let provinceObj = SG_AREA[key]
            if (provinceObj.name === province) {
                result.province_code = key
                if (provinceObj['city']) {
                    let cityListObj = provinceObj['city']
                    for (let ckey in cityListObj) {
                        let cityObj = cityListObj[ckey]
                        if (cityObj.name === city) {
                            result.city_code = ckey
                            if (cityObj['areas']) {
                                for (let dkey in cityObj['areas']) {
                                    let districtObj = cityObj['areas'][dkey]
                                    if (districtObj.name === district) {
                                        result.district_code = dkey
                                        return result
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return false
    }
}
export default addressSelectObj
